import React, { useContext } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { UniversalContext } from '../../../_universal';
import { SchedulingSessionStateContext } from '../SchedulingSessionState';

/**
 * A higher order component for getting the widget settings from the context as well as the universalContext.
 */
export default function withCustomContextsComponent(WrappedComponent) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name;
  const WithCustomContexts = props => {
    const universalContext = useContext(UniversalContext);

    const { widgetSettings, screenerStatus, prefillToken, trackerData } = useContext(
      SchedulingSessionStateContext
    );
    return (
      <WrappedComponent
        universalContext={universalContext}
        widgetSettings={widgetSettings}
        patientScreenerStatus={screenerStatus}
        prefillToken={prefillToken}
        trackerData={trackerData}
        {...props}
      />
    );
  };
  WithCustomContexts.displayName = `withCustomContexts(${componentName})`;
  WithCustomContexts.WrappedComponent = WrappedComponent;
  hoistNonReactStatic(WithCustomContexts, WrappedComponent);

  return WithCustomContexts;
}
